import { HelpTip } from './types';

export const USER_TIPS = {
  usersTable: {
    title: { fr: 'Les utilisateurs', en: 'Users' },
    text: {
      fr: "Comptes ayant accès au back-office et à l'application d'inspection. Vous ne voyez que les utilisateurs rattachés aux structures de votre périmètre (groupes, sociétés, exploitations). Les droits de chaque compte dépendent de ses rôles.",
      en: 'Accounts with access to the back-office and the inspection app. You only see the users linked to the structures of your scope (groups, companies, branches). The rights of each account depend on its roles.',
    },
    docSlug: 'liste-des-utilisateurs',
  },
  statusColumn: {
    title: { fr: 'État', en: 'Status' },
    text: {
      fr: "Un utilisateur inactif ne peut plus se connecter. Un utilisateur qui possède encore des rôles ne peut pas être désactivé : retirez d'abord ses rôles depuis sa fiche.",
      en: 'An inactive user can no longer log in. A user who still has roles cannot be deactivated: first remove their roles from their profile.',
    },
    docSlug: 'liste-des-utilisateurs',
  },
  groupsColumn: {
    title: { fr: 'Groupes', en: 'Groups' },
    text: {
      fr: "Groupes dont l'utilisateur est directeur de groupe. Les sociétés et exploitations qui lui sont attribuées sont visibles sur sa fiche.",
      en: 'Groups the user manages as group manager. The companies and branches assigned to them are visible on their profile.',
    },
    docSlug: 'roles-et-perimetres',
  },
  inspectionsColumn: {
    title: { fr: 'Inspections', en: 'Inspections' },
    text: {
      fr: "Nombre d'inspections terminées réalisées par cet utilisateur. La flèche ouvre l'onglet Inspections de sa fiche.",
      en: 'Number of completed inspections performed by this user. The arrow opens the Inspections tab of their profile.',
    },
    docSlug: 'liste-des-utilisateurs',
  },
  rolesSection: {
    title: { fr: 'Rôles et périmètres', en: 'Roles and scopes' },
    text: {
      fr: "Cochez un rôle pour l'attribuer. Administrateur et modérateur sont des rôles globaux (réservés aux administrateurs). Les rôles directeur de groupe, directeur de société, directeur d'exploitation et agent s'appliquent aux structures que vous ajoutez avec le bouton « + ». Décocher un rôle retire l'utilisateur de toutes les structures associées à ce rôle.",
      en: 'Tick a role to grant it. Administrator and moderator are global roles (reserved to administrators). Group manager, company manager, branch manager and branch agent roles apply to the structures you add with the "+" button. Unticking a role removes the user from every structure linked to that role.',
    },
    docSlug: 'modifier-un-utilisateur',
  },
} satisfies Record<string, HelpTip>;
